module.exports = __webpack_public_path__ + "static/media/ball_4_8.0513a70a.mp3";